import { useCombinedStore } from "./useCombinedStore";
import {
  type RoleManagementStore,
  type UseCombinedStore,
  type UserManagementStore,
} from "./useCombinedStore.types";

export { useLayoutManagementStore } from "@ucchub/ui";

// Simulate multiple stores by exporting a subset of the state contained within the combined store
export const useUserManagementStore: UseCombinedStore<UserManagementStore> =
  useCombinedStore;
export const useRoleManagementStore: UseCombinedStore<RoleManagementStore> =
  useCombinedStore;
